import { AuthAside } from "../../AuthAside";

export default function Left() {
  return (
    <>
      <AuthAside />
    </>
  );
}
